import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import moment from 'moment';  
import './ModalComponent.css';  
import Loader from '../Loader/Loader';
import { useNavigate } from 'react-router-dom';

const ModalComponent = ({ isOpen, onRequestClose, offerId }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [area, setArea] = useState('');
    const [propertyName, setPropertyName] = useState('');
    const [developerName, setDeveloperName] = useState('');
    const [location, setLocation] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [numberOfRooms, setNumberOfRooms] = useState('');
    const [price, setPrice] = useState('');
    const [propertyType, setPropertyType] = useState('');
    const [propertyStatus, setPropertyStatus] = useState('');
    const [description, setDescription] = useState('');
    const [isFeatured, setIsFeatured] = useState('');
    const [formattedExpDate, setFormattedExpDate] = useState('');
    const [images, setImages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen && offerId) {
            getDetail(offerId);
        }
    }, [isOpen, offerId]);


    const handleDetailButtonClick = () => {
        onRequestClose(); // Close the modal
        navigate(`/propertyOfferDetail/${offerId}`); // Navigate to the detail screen
    };

    const getDetail = async (offerId) => {
        setLoading(true);
        const datas = {
            "verification_token": "123456",
            "table": "property_offers",
            "id": offerId,
        };

        try {
            const result = await axios.post('https://appvelo.com/realestateOfferAPI/get', datas);

            setLoading(false);

            if (result?.data?.message === "success") {
                const fetchedData = result?.data?.data[0];

                // Set state variables
                setArea(fetchedData?.Area);
                setPropertyName(fetchedData?.PropertyName);
                setDeveloperName(fetchedData?.DeveloperName);
                setLocation(fetchedData?.Location);
                setContactNumber(fetchedData?.ContactNumber);
                setNumberOfRooms(fetchedData?.NumberOfRooms);
                setPrice(fetchedData?.Price);
                setPropertyType(fetchedData?.PropertyType);
                setPropertyStatus(fetchedData?.PropertyStatus);
                setDescription(fetchedData?.Description);
                setIsFeatured(fetchedData?.is_featured === "1" ? "Yes" : "No");
                setFormattedExpDate(moment(fetchedData?.ExpiryDate).format("ddd, MMM D, YYYY h:mm A"));

                // Parse and set the images array
                const parsedImages = parseImageUrls(fetchedData?.Pictures);
                setImages(parsedImages);
                console.log(images, "A>A>S>A>>F>")
            } else {
                console.error("Something went wrong");
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoading(false);
        }
    };

    const parseImageUrls = (pictures) => {
        if (!pictures) return [];

        // Remove extra quotes and parse the string into an array
        const cleanedPictures = pictures
            .replace(/['"]/g, '') // Remove all single and double quotes
            .split(',') // Split by comma
            .map(url => url.trim()); // Trim whitespace from each URL

        return cleanedPictures;
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            ariaHideApp={false}
            // className="modal"
          
             overlayClassName="modal-overlay"
        >
            <div className="modal-header">
                <h2>Detail</h2>
                <button className="close-button" onClick={onRequestClose}>&times;</button>
            </div>

            <Loader isLoading={loading} />
            <div className="modal-content" 
       
            >
                {/* Displaying parsed data */}
                <img src={images[0]} alt="Offer" className="offer-image" />
                <h3 className="offer-title">{propertyName}</h3>

                <div className="location">
                    <span className="location-icon">📍</span>
                    <span>{location}</span>
                </div>

                <p className="description">{description}</p>

                <div className="detail-field">
                    <strong>Developer Name: </strong>{developerName}
                </div>
                <div className="detail-field">
                    <strong>Number of Rooms: </strong>{numberOfRooms}
                </div>
                <div className="detail-field">
                    <strong>Property Type: </strong>{propertyType}
                </div>
                <div className="detail-field">
                    <strong>Area: </strong>{area} sq.ft
                </div>
                <div className="detail-field">
                    <strong>Contact Number: </strong>{contactNumber}
                </div>
                <div className="detail-field">
                    <strong>Price: </strong>${price}
                </div>

                <div className="date-field">
                    <span className="clock-icon">⏰</span>
                    <span>{formattedExpDate}</span>
                </div>

                <button className="details-button" onClick={handleDetailButtonClick} >Details</button>
            </div>

        </Modal>
    );
};

export default ModalComponent;
